import React, { useEffect, useState } from 'react';

const MAX_VALUE = 250;

const FeeSlider: React.FC<{
  setOrder: (order: number) => void;
  initialOrder: number;
  enabled: boolean;
}> = ({ setOrder, initialOrder, enabled }) => {
  const [value, setValue] = useState(0);
  const [lastValue, setLastValue] = useState<number>(0);

  useEffect(() => {
    if (initialOrder) {
      setValue(initialOrder);
      setLastValue(initialOrder);
    }
  }, [initialOrder]);

  const handleChange = (event: any) => {
    setValue(parseInt(event.target.value, 10));
  };

  const handleSubmit = (event: any) => {
    const currentValue = parseInt(event.target.value, 10);
    if (lastValue === currentValue) return;

    setOrder(currentValue);

    setLastValue(currentValue);
  };

  const handleIncrement = () => {
    const newValue = Math.min(value + 1, MAX_VALUE);
    if (newValue !== value) {
      setValue(newValue);
      setOrder(newValue);
      setLastValue(newValue);
    }
  };

  const handleDecrement = () => {
    const newValue = Math.max(value - 1, 0);
    if (newValue !== value) {
      setValue(newValue);
      setOrder(newValue);
      setLastValue(newValue);
    }
  };

  return (
    <div className={!enabled ? 'saas-sliderdisabled' : 'saas-slider'} style={styles.container}>
      <style>{thumbStyles}</style>
      <div style={styles.textContainer}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
          <div style={styles.title}>Fee (Unit/Month)</div>
          <div style={enabled ? styles.discount : styles.disabledDiscount}>${(value * 0.01).toFixed(2)}</div>
        </div>
        <div style={styles.sliderContainer}>
          <button
            style={styles.button('#9FA5B1')}
            onClick={handleDecrement}
            aria-label="Decrease value"
            disabled={!enabled}
          >
            −
          </button>
          <input
            type="range"
            min="0"
            max={MAX_VALUE}
            value={value}
            onChange={handleChange}
            onMouseUp={handleSubmit}
            style={styles.slider(value, enabled)}
            disabled={!enabled}
          />
          <button
            style={styles.button('#9FA5B1')}
            onClick={handleIncrement}
            aria-label="Increase value"
            disabled={!enabled}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

const thumbStyles = `
  .saas-slider input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 1.6vh;
    height: 1.6vh;
    background: #00AB9B;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }

  .saas-sliderdisabled input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 1.6vh;
    height: 1.6vh;
    background: #00AB9B;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }

  .saas-slider input[type="range"]::-moz-range-thumb {
    width: 1.6vh;
    height: 1.6vh;
    background: #00AB9B;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }

  .saas-sliderdisabled input[type="range"]::-moz-range-thumb {
    width: 1.6vh;
    height: 1.6vh;
    background: #9FA5B1;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }

  .saas-slider input[type="range"]::-ms-thumb {
    width: 1.6vh;
    height: 1.6vh;
    background: #00AB9B;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }

  .saas-sliderdisabled input[type="range"]::-ms-thumb {
    width: 1.6vh;
    height: 1.6vh;
    background: #9FA5B1;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }
`;

const styles = {
  sliderContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '0.8vh',
  },
  button: (color: string): React.CSSProperties => ({
    border: 'none',
    color: color,
    backgroundColor: 'white',
    cursor: 'pointer',
    fontSize: '1.6vh',
    fontWeight: 'bold',
    margin: 0,
    padding: 0,
    lineHeight: 1,
  }),
  slider: (value: number, enabled: boolean): React.CSSProperties => {
    // Map value from 0 to 50 range to 0% to 100% for gradient
    const percentage = (value / MAX_VALUE) * 100;
    const grayColor = 'rgba(16, 29, 59, 0.1)';
    const backgroundGradient = enabled
      ? `linear-gradient(90deg, #00AB9B ${percentage}%, ${grayColor} ${percentage}%)`
      : `linear-gradient(90deg, #9FA5B1 ${percentage}%, ${grayColor} ${percentage}%)`;

    return {
      width: '100%',
      appearance: 'none' as 'none',
      height: '0.4vh',
      borderRadius: '0.5vh',
      background: backgroundGradient,
      outline: 'none',
      opacity: '0.9',
      transition: 'opacity 0.2s, background 0.2s',
    };
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  textContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'start',
    gap: '0.4vh',
  },
  title: {
    fontSize: '1.4vh',
    fontWeight: '700',
    color: '#101D3B',
  },
  discount: {
    fontSize: '1.4vh',
    fontWeight: '700',
    color: '#00AB9B',
  },
  disabledDiscount: {
    fontSize: '1.4vh',
    fontWeight: '700',
    color: '#9FA5B1',
  },
};

export default FeeSlider;
